// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#big-box {
  display: flex;
  width: 345px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
}

.add-photo-text-box{
  display: flex;
  width: 109px;
  height: 109px;
  padding: 50px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background-color: #fbfbfb;
  border: 2px solid #D62311;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.add-photo-text{
  color: #D62311;
  text-align: center;
  font-family: "Mecherle Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
}
.add-photos-header{
  text-align: center;
  font-family: "Mecherle Sans";
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  margin-top:40px;
  margin-bottom:40px;
}
.upload-img{
  background-image: url(/assets/img/image_32px.svg);
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color:#4a4a4a;
  background-color: #F7F0E4;
}

.upload-text{
  max-width: 107.75px;
  text-align: center;
  font-family: "Mecherle Sans";
  color: #4a4a4a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display:inline-block;
  vertical-align: bottom;;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.photo-check{
  background-image: url('success_32.svg');
  width: 109.667px;
  height: 109.75px;
}
.upload-photo-box{
  display: flex;
  background-color: #F7F0E4;
  width: 109.667px;
  height: 109.75px;
  padding: 16px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: - 16px;
}
.uploaded-photo{
  display: flex;
  width: 109.667px;
  height: 109.75px;

  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
.photo-uploaded-pic{
  display: flex;
  background-color: #F7F0E4;
  width: 109.667px;
  height: 109.75px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

}
.checkmark-box{
  display: flex;
  width: 109.667px;
  height: 109.75px;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 4px;
  /* margin-top: -46px;
  margin-left: -50px; */

}
.photo-counter {
  color: #212121;
  font-family: "Mecherle Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px; /* 150% */
  text-transform: uppercase;
  margin-top: 32px;
}
.photo-grid{
  display: grid;
  width: 345px;
  grid-template-columns: repeat(3,1fr);
  margin-bottom: 32px;
  margin-top: 0px;
}
.button-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
}
.-oneX-btn-primary:disabled {
  background-color: #D62311;
  color: #fbfbfb;
  opacity: 0.3;
  cursor: not-allowed;
}

.-oneX-btn-secondary:disabled {
  background-color: #fbfbfb;
  color: #D62311;
  border-color: #D62311;
  opacity: 0.3;
  cursor: not-allowed;
}
.photo-toggle-selected{
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-bottom: 4px;
  margin-left: -28px;
}

.photo-toggle-unselected{

  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-bottom: 4px;
  margin-left: -28px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/damage-details/damage-photos-add/damage-photos-add.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uCAAyD;EACzD,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;;EAEhB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;;AAEV;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB;uBACqB;;AAEvB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["#big-box {\n  display: flex;\n  width: 345px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 32px;\n}\n\n.add-photo-text-box{\n  display: flex;\n  width: 109px;\n  height: 109px;\n  padding: 50px 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  background-color: #fbfbfb;\n  border: 2px solid #D62311;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n.add-photo-text{\n  color: #D62311;\n  text-align: center;\n  font-family: \"Mecherle Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n}\n.add-photos-header{\n  text-align: center;\n  font-family: \"Mecherle Sans\";\n  font-size: 25px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 25px;\n  margin-top:40px;\n  margin-bottom:40px;\n}\n.upload-img{\n  background-image: url(/assets/img/image_32px.svg);\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  color:#4a4a4a;\n  background-color: #F7F0E4;\n}\n\n.upload-text{\n  max-width: 107.75px;\n  text-align: center;\n  font-family: \"Mecherle Sans\";\n  color: #4a4a4a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  display:inline-block;\n  vertical-align: bottom;;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.photo-check{\n  background-image: url(../../../assets/img/success_32.svg);\n  width: 109.667px;\n  height: 109.75px;\n}\n.upload-photo-box{\n  display: flex;\n  background-color: #F7F0E4;\n  width: 109.667px;\n  height: 109.75px;\n  padding: 16px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: - 16px;\n}\n.uploaded-photo{\n  display: flex;\n  width: 109.667px;\n  height: 109.75px;\n\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.photo-uploaded-pic{\n  display: flex;\n  background-color: #F7F0E4;\n  width: 109.667px;\n  height: 109.75px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n}\n.checkmark-box{\n  display: flex;\n  width: 109.667px;\n  height: 109.75px;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 4px;\n  /* margin-top: -46px;\n  margin-left: -50px; */\n\n}\n.photo-counter {\n  color: #212121;\n  font-family: \"Mecherle Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 21px; /* 150% */\n  text-transform: uppercase;\n  margin-top: 32px;\n}\n.photo-grid{\n  display: grid;\n  width: 345px;\n  grid-template-columns: repeat(3,1fr);\n  margin-bottom: 32px;\n  margin-top: 0px;\n}\n.button-box{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n}\n.-oneX-btn-primary:disabled {\n  background-color: #D62311;\n  color: #fbfbfb;\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.-oneX-btn-secondary:disabled {\n  background-color: #fbfbfb;\n  color: #D62311;\n  border-color: #D62311;\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n.photo-toggle-selected{\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  margin-bottom: 4px;\n  margin-left: -28px;\n}\n\n.photo-toggle-unselected{\n\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  margin-bottom: 4px;\n  margin-left: -28px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
